"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./beautyCard.scss");
var BeautyCard = /** @class */ (function (_super) {
    __extends(BeautyCard, _super);
    function BeautyCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BeautyCard.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, style = _a.style, label = _a.label;
        return (react_1.default.createElement("div", { "data-aos": "zoom-out", style: style ? style : {}, className: "beauty-container " + (className ? className : '') + " " },
            children,
            react_1.default.createElement("div", { className: "beauty-card-parent " },
                react_1.default.createElement("div", { className: "beauty-card-cover" }),
                react_1.default.createElement("div", { className: 'beauty-card-label' }, label))));
    };
    return BeautyCard;
}(react_1.Component));
exports.BeautyCard = BeautyCard;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Peojects/components/BeautyCard.tsx
// module id = 82
// module chunks = 0